import { PayPalMessages, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { MessageCircle } from "lucide-react";
import { usePaymentMethods } from "@/components/checkout/PaymentMethods";
import { useLang } from "@/lib/i18n";

/** Message officiel PayPal « Payer en 4X » (30 € à 2 000 €) : PayPal impose son propre message, aucun texte personnalisé. */
export function PayLaterMessage({ amount }) {
  const { data } = usePaymentMethods();
  const pp = (Array.isArray(data) ? data : []).find((m) => m.id === "paypal" && m.client_id);
  const { lang } = useLang();
  if (!pp || !(amount >= 30)) return null;
  return (
    <div data-testid="paylater-message" className="mt-3 min-h-6">
      <PayPalScriptProvider key={lang} options={{ clientId: pp.client_id, currency: "EUR", locale: lang === "en" ? "en_GB" : "fr_FR", components: "messages", "enable-funding": "paylater" }}>
        <PayPalMessages style={{ layout: "text", color: "white" }} amount={amount} />
      </PayPalScriptProvider>
    </div>
  );
}

export const WHATSAPP = "33625995502";

export function WhatsAppAdvice({ productName }) {
  const { t, lang } = useLang();
  const text = encodeURIComponent(lang === "en"
    ? `Hello Ozentya, I would like some advice${productName ? ` about "${productName}"` : ""} for my hair.`
    : `Bonjour Ozentya, j'aimerais un conseil${productName ? ` sur « ${productName} »` : ""} pour mes cheveux.`);
  return (
    <a href={`https://wa.me/${WHATSAPP}?text=${text}`} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-advice"
      className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#25D366]/60 px-5 py-3 text-sm text-[var(--parchment)] transition-colors hover:bg-[#25D366]/15">
      <MessageCircle className="h-4 w-4 text-[#25D366]" />{t("Conseil gratuit sur WhatsApp")}
    </a>
  );
}
